import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { ScopeChangeRequestFinalizedDialog } from '@/features/admin/scope-change-requests/ScopeChangeRequestFinalizedDialog'
import { type ScopeChangeRequestFinalizedDialogViewModel } from './ScopeChangeRequestFinalizedDialogViewModel'

export interface ScopeChangeRequestFinalizedDialogContainerProps {
  vm: ScopeChangeRequestFinalizedDialogViewModel
}

export const ScopeChangeRequestFinalizedDialogContainer = observer(
  function ScopeChangeRequestFinalizedDialogContainer({
    vm,
  }: ScopeChangeRequestFinalizedDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    return (
      <ScopeChangeRequestFinalizedDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        corporateMode={shellInfo.corporateMode}
        createdByName={vm.scopeChangeRequest.createdBy.displayName}
        isClientApprovalRequired={
          vm.scopeChangeRequest.workspace.config.combinedPricing
            .jobScopeRequireClientApproval
        }
        clientName={vm.scopeChangeRequest.jobClient?.member.displayName}
      />
    )
  },
)
